<template>
  <div class="custom-tree">
    <div class="title">
      {{ title }} <span class="add" v-if="editable" @click="addNew">新增</span>
    </div>
    <el-tree ref="tree" :data="data" node-key="id" default-expand-all @node-drag-start="handleDragStart"
      @node-drag-end="handleDragEnd" draggable @node-click="handelClickNode" disabled>
      <div class="custom-tree-node" slot-scope="{ node, data }" :class="{ active: dialogItem.id == data.id }">
        <span>{{ node.label }}</span>
        <span class="custom-icon" v-if="editable">
          <i class="el-icon-circle-plus-outline" @click.stop="handelClick('add', data)"></i>
          <el-popconfirm title="确定删除吗？" @confirm="handelClick('delete', data)"
            v-if="!(data.children && data.children.length)">
            <el-link slot="reference">删除</el-link>
          </el-popconfirm>
        </span>
      </div>
    </el-tree>

    <el-dialog :visible.sync="dialogVisible" @closed="dialogVisible = false" title="新增栏目" :close-on-click-modal="false">
      <CustomForm ref="CustomForm" :data="addFormData" @change="handelForm" />
    </el-dialog>
  </div>
</template>

<script>
import CustomForm from "@/components/custom/CustomForm";
export default {
  components: { CustomForm },
  data() {
    return {
      data: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      dialogVisible: false,
      dialogType: "add",
      addFormData: [
        {
          label: "pid",
          prop: "pid",
          type: "parent",
          value: "tree",
          span: 24,
          hidden: true,
        },
        {
          label: "栏目名称",
          prop: "name",
          type: "input",
          value: "",
          required: true,
          span: 24,
        },
        {
          label: "栏目ID",
          prop: "id",
          type: "input",
          value: "",
          required: true,
          span: 24,
        },
        {
          label: "展示类型",
          prop: "areaCode",
          type: "select",
          opt: [
            { label: "横幅", value: "banner" },
            { label: "横排", value: "horizontal" },
            { label: "竖排", value: "vertical" },
          ],
          value: "",
          span: 24,
        },
        {
          label: "图片栏目",
          prop: "imgChannel",
          type: "switch",
          value: true,
          span: 12,
        },
        {
          label: "允许投稿",
          prop: "memberPost",
          type: "switch",
          value: true,
          span: 12,
        },
        {
          label: "栏目统计",
          prop: "stat",
          type: "switch",
          value: false,
          span: 12,
        },
        {
          label: "首页展示",
          prop: "preview",
          type: "switch",
          value: true,
          span: 12,
        },
      ],
      dialogItem: {
        areaCode: "",
        id: "",
        imgChannel: true,
        memberPost: true,
        name: "",
        pid: "tree",
      },
    };
  },
  props: {
    title: {
      type: String,
      default: "栏目列表",
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.initTree();
  },
  methods: {
    handelForm(data) {
      let params = Object.assign({}, data);
      let url = "";
      let ajaxType = "";
      if (!Object.keys(data).length) {
        this.dialogVisible = false;
        return;
      }
      switch (this.dialogType) {
        case "add":
          let allNode = [];
          getData(this.$refs.tree.data);
          function getData(data) {
            data.forEach((el) => {
              allNode.push(el);
              if (el.children.length > 0) {
                getData(el.children);
              }
            });
          }
          params.sortOrder = allNode.length + 1;
          params.status = "active";
          url = this.$api.ContentManagement.addMgrcat;
          ajaxType = "post";
          break;
        case "edit":
          url = this.$api.ContentManagement.updateMgrcat + this.dialogItem.id;
          ajaxType = "post";
          break;
        case "delete":
          url = this.$api.ContentManagement.deleteMgrcat + this.dialogItem.id;
          ajaxType = "get";
          params = "";
          break;
      }
      this.$https[ajaxType](url, params).then((res) => {
        this.$message.success("操作成功");
        this.initTree();
        this.dialogVisible = false;
      });
    },
    handelClickNode(data) {
      this.dialogItem = Object.assign({}, data);
      this.$emit("change", data);
    },
    addNew() {
      this.addFormData = [
        {
          label: "pid",
          prop: "pid",
          type: "parent",
          value: "tree",
          span: 24,
          hidden: true,
        },
        {
          label: "栏目名称",
          prop: "name",
          type: "input",
          value: "",
          required: true,
          span: 24,
        },
        {
          label: "栏目ID",
          prop: "id",
          type: "input",
          value: "",
          required: true,
          span: 24,
        },
        {
          label: "展示类型",
          prop: "areaCode",
          type: "select",
          opt: [
            { label: "横幅", value: "banner" },
            { label: "横排", value: "horizontal" },
            { label: "竖排", value: "vertical" },
          ],
          value: "",
          span: 24,
        },
        {
          label: "图片栏目",
          prop: "imgChannel",
          type: "switch",
          value: true,
          span: 12,
        },
        {
          label: "允许投稿",
          prop: "memberPost",
          type: "switch",
          value: true,
          span: 12,
        },
        {
          label: "栏目统计",
          prop: "stat",
          type: "switch",
          value: false,
          span: 12,
        },
        {
          label: "首页展示",
          prop: "preview",
          type: "switch",
          value: true,
          span: 12,
        },
      ];
      this.dialogVisible = true;
    },
    handelClick(type, data) {
      this.dialogType = type;
      if (type == "add") {
        this.dialogItem = {
          areaCode: "",
          id: "",
          imgChannel: true,
          memberPost: true,
          name: "",
          pid: data.id,
          sortOrder: 0,
        };
        this.addFormData = this.addFormData.map((el) => {
          return Object.assign(el, { value: this.dialogItem[el.prop] });
        });
        this.dialogVisible = true;
        this.$emit("change", data);
      } else {
        this.dialogItem = Object.assign({}, data)
        this.handelForm(data)
        this.$emit("change", false);
      }
    },
    handleDragStart(node) {
      this.dialogItem = node.data;
    },
    handleDragEnd(draggingNode, dropNode, dropType) {
      let allNode = [];
      getData(this.$refs.tree.data);
      function getData(data) {
        data.forEach((el) => {
          allNode.push(el);
          if (el.children.length > 0) {
            getData(el.children);
          }
        });
      }
      let sortMap = {};
      allNode.forEach((el, index) => {
        sortMap[el.id] = index + 1;
      });
      this.$emit("change", draggingNode);
      this.$https
        .post(this.$api.ContentManagement.sortting + draggingNode.data.id, {
          pid:
            !dropNode || dropType == "none"
              ? "tree"
              : dropType == "inner"
                ? dropNode.data.id
                : dropNode.data.pid,
          sortMap: sortMap,
        })
        .then((res) => {
          this.$message.success("新建成功");
          this.initTree();
        });
    },
    initTree() {
      this.$https.get(this.$api.ContentManagement.mgrcatList).then((res) => {
        this.data = changeTreeData(res, "tree");
      });
      function changeTreeData(data, pid) {
        return data
          .filter((el) => el.pid == pid)
          .map((el) => {
            return {
              ...el,
              label: el.name,
              children: changeTreeData(data, el.id),
            };
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-tree {
  position: relative;
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 5px;

  .title {
    padding: 0 10px;
    font-size: 16px;
    line-height: 40px;
    font-weight: bold;
    border-bottom: 1px solid #dedede;

    .add {
      float: right;
      cursor: pointer;
      font-size: 13px;
      color: #409eff;
    }
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    line-height: 30px;

    .custom-icon {
      display: none;

      i {
        padding: 2px;
      }
    }

    &:hover {
      .custom-icon {
        display: inline;
      }
    }
  }

  .active {
    color: #409eff;
  }
}

/deep/.el-tree-node__content {
  height: 30px !important;
  // border-bottom: 1px solid #eee;
}

.btns {
  text-align: center;
}

/deep/.el-dialog__body {
  padding: 0 20px 20px 20px;
}
</style>